module.exports = __webpack_public_path__ + "static/assets/8fd077c1b22ecbe2c70864b4245c8100.gif";